import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  showCategoryModalForAddEdit,
  showCategoryModalForDelete,
} from './store/actions';
import HamburgerDropdown from '../shared/hamburgerDropdown.component';

import { UserPropTypes } from '../../shared/propTypes/users';
import getPermissionsFromTree from '../../shared/authorization/getPermissionsFromTree.helper';
import permissionPaths from '../../shared/authorization/permissionPaths';
import permissionTypes from '../../shared/authorization/permissionTypes';
import { userSelector } from '../../shared/store/selectors';


class CategoriesAndTagsMenu extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    }).isRequired,

    category: PropTypes.shape({
      categoryName: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      catView: PropTypes.string.isRequired,
      defaultTag: PropTypes.string,
      subCategoryName: PropTypes.string,
    }),
    showCategoryModalForAddEdit: PropTypes.func.isRequired,
    showCategoryModalForDelete: PropTypes.func.isRequired,

    disabledActions: PropTypes.shape({
      categoryNotSelected: PropTypes.bool.isRequired,
    }).isRequired,

    canModify: PropTypes.bool.isRequired,
    canModifyCategories: PropTypes.bool.isRequired,
    canModifyCurrentCategory: PropTypes.bool.isRequired,

    templateFileName: PropTypes.string.isRequired,
    templatePath: PropTypes.string.isRequired,
    exportToExcel: PropTypes.func.isRequired,
    fileToImportChange: PropTypes.func.isRequired,
    fileToImportSelect: PropTypes.func.isRequired,

    user: UserPropTypes,
  };

  showCategoryModalForAdd = () => {
    const { showCategoryModalForAddEdit } = this.props;
    showCategoryModalForAddEdit();
  };

  showCategoryModalForEdit = () => {
    const { showCategoryModalForAddEdit, category } = this.props;

    showCategoryModalForAddEdit(category);
  };

  showCategoryModalForDelete = () => {
    const { period, category, showCategoryModalForDelete } = this.props;

    showCategoryModalForDelete({ periodName: period.name, categoryName: category.categoryName });
  };

  additionalItems = () => {
    const { disabledActions, canModifyCategories, user, canModifyCurrentCategory } = this.props;

    const permission = getPermissionsFromTree(
      user.permissions, permissionPaths.CATEGORIES_AND_TAGS
    )[permissionTypes.MODIFY_CATEGORIES];

    if (!permission) {
      return [];
    }

    return [
      (
        <button
          key="add-category-button"
          className="hamburger-action link-button"
          tabIndex="0"
          onClick={this.showCategoryModalForAdd}
          disabled={!canModifyCategories}
        >
          Add Category
        </button>
      ),
      (
        <button
          key="edit-category-button"
          className="hamburger-action link-button"
          tabIndex="0"
          onClick={this.showCategoryModalForEdit}
          disabled={disabledActions.categoryNotSelected || !canModifyCategories || !canModifyCurrentCategory}
        >
          Edit Category
        </button>
      ),
      (
        <button
          key="remove-category-button"
          className="hamburger-action link-button"
          tabIndex="0"
          onClick={this.showCategoryModalForDelete}
          disabled={disabledActions.categoryNotSelected || !canModifyCurrentCategory}
        >
          Delete Category
        </button>
      ),
    ];
  };

  render() {
    const {
      canModify,
      templateFileName,
      templatePath,
      exportToExcel,
      disabledActions: {
        categoryNotSelected,
      },
      fileToImportChange,
      fileToImportSelect,
      canModifyCurrentCategory,
    } = this.props;

    return (
      <HamburgerDropdown
        canModify={canModify && canModifyCurrentCategory}
        additionalItems={this.additionalItems()}
        templateFileName={templateFileName}
        templatePath={templatePath}
        exportToExcel={exportToExcel}
        disableImporting={categoryNotSelected}
        disableAddingEntity={categoryNotSelected}
        disableExporting={categoryNotSelected}
        fileToImportChange={fileToImportChange}
        fileToImportSelect={fileToImportSelect}
      />
    );
  }
}

export default connect(
  state => ({
    user: userSelector(state),
  }),
  {
    showCategoryModalForAddEdit,
    showCategoryModalForDelete,
  }
)(CategoriesAndTagsMenu);
